/* eslint-disable */
import React, { useState } from "react";
import "contents/assets/scss/page/books.scss";
import Paging from "../../component/Inc/Paging";
import PopInvoice from "./_PopInvoice";

const InOutDetail = () => {
  const [modalInvoiceOpen, setModalInvoiceOpen] = useState(false);

  return (
    <main className="com_container com_books p_books_inOut_detail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu3_6">
            교재 불출 요청목록
            <span className="bar" />
            <span className="point_txt">상세보기</span>
          </h2>
        </section>
        <section className="com_pg_container">
          <section className="box box-1 type_column">
            <div className="detail_tit dot">교재 불출 요약</div>
            <div className="content_wrap">
              <div className="accordian">
                <p className="title">직접 수령 (45)</p>
                <div className="btn_wrap">
                  <button
                    type="button"
                    className="icon_arrow_down_white active"
                  ></button>
                </div>
              </div>
              <div className="textbook_box">
                <div className="box_tit">수령자</div>
                <div className="com_info">
                  <p className="name">홍길동103</p>
                  <span className="dot" />
                  <p className="value">010-1234-1344</p>
                </div>
                <div className="box_tit">교재 신청 목록</div>
                <div className="textbook_detail">
                  <p className="textbook_title">
                    1. 사탐 중2 사회탐구 교재 (42권)
                  </p>
                  <p className="textbook_title">
                    2. 수학 중2 수학탐구 교재 (12권)
                  </p>
                  <p className="textbook_title">
                    3. 사탐 중2 사회탐구 교재 (42권)
                  </p>
                  <p className="textbook_title">
                    4. 수학 중2 수학탐구 교재 (12권)
                  </p>
                  <p className="textbook_title">
                    5. 사탐 중2 사회탐구 교재 (42권)
                  </p>
                  <p className="textbook_title">
                    6. 수학 중2 수학탐구 교재 (12권)
                  </p>
                </div>
              </div>
              <div className="accordian">
                <p className="title">선불 발송 (32)</p>
                <div className="btn_wrap">
                  <button
                    type="button"
                    className="icon_arrow_down_white active"
                  ></button>
                </div>
              </div>
              <div className="com_board_box">
                <div className="board_item">
                  <div className="info">
                    <span className="tit">교재명</span>
                    <span className="cont">사탐 중2 사회탐구 교재 (4권)</span>
                  </div>
                  <div className="info">
                    <span className="tit">수령자</span>
                    <span className="cont">
                      김학생103ㆍ010-1234-1324
                      <br />
                      경기도 수원시 수원로123 33 123동 123호
                    </span>
                  </div>
                </div>
              </div>
              <div className="accordian">
                <p className="title">착불 발송 (12)</p>
                <div className="btn_wrap">
                  <button
                    type="button"
                    className="icon_arrow_down_white"
                  ></button>
                </div>
              </div>
            </div>
            <div className="com_btn_wrap center">
              <button className="com_btn black xs btn_print">인쇄하기</button>
							<button className="com_btn black xs btn_down_orange">다운로드</button>
            </div>
          </section>
          <section className="box">
            <table className="com_board_list">
              <colgroup>
                <col width="7%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="13%" />
                <col width="7%" />
                <col width="13%" />
                <col width="10%" />
                <col width="15%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>선택</th>
                  <th>
                    <button className="arrow active" />
                    요청일
                  </th>
                  <th>요청 자</th>
                  <th>교부 대상</th>
                  <th>송장번호</th>
                  <th>교재코드</th>
                  <th>교재명</th>
                  <th>교재권수</th>
                  <th>발송ㆍ발송불가</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td className="td_date">2022,08,25</td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>로젠택배<br/>
									12312-3621312</td>
                  <td>13244</td>
                  <td>사탐 중2 2032</td>
                  <td>4</td>
                  <td>
                    <button className="btn_link blue">
                      발송
                      <br />
                      2022, 05, 23 11:30
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td className="td_date">2022,08,25</td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>로젠택배<br/>
									12312-3621312</td>
                  <td>13244</td>
                  <td>사탐 중2 2032</td>
                  <td>4</td>
                  <td>
                    <button className="btn_link">승인 요청</button>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td className="td_date">2022,08,25</td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>로젠택배<br/>
									12312-3621312</td>
                  <td>13244</td>
                  <td>사탐 중2 2032</td>
                  <td>4</td>
                  <td>
                    <button className="btn_link red">
                      제고 부족
                      <br />
                      2022, 05, 23 11:30
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td className="td_date">2022,08,25</td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>로젠택배<br/>
									12312-3621312</td>
                  <td>13244</td>
                  <td>사탐 중2 2032</td>
                  <td>4</td>
                  <td>
                    <button className="btn_link">승인 요청</button>
                  </td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td className="td_date">2022,08,25</td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>로젠택배<br/>
									12312-3621312</td>
                  <td>13244</td>
                  <td>사탐 중2 2032</td>
                  <td>4</td>
                  <td>
                    <button className="btn_link">승인 요청</button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>1</td>
                      <td>
                        <input type="checkbox" id="chk00" className="com_chk" />
                        <label htmlFor="chk00"></label>
                      </td>
                      <td className="td_date">2022,08,25</td>
                      <td>
                        <button className="btn_link">홍길동103</button>
                      </td>
                      <td>
                        <button className="btn_link">홍길동103</button>
                      </td>
                      <td>로젠택배<br/>
									12312-3621312</td>
                      <td>13244</td>
                      <td>사탐 중2 2032</td>
                      <td>4</td>
                      <td>
                        <button className="btn_link">승인 요청</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
            <div className="com_btn_wrap center">
              <button className="com_btn blue xs" onClick={()=> setModalInvoiceOpen(true)}>발송</button>
              <button className="com_btn red xs" >재고 부족</button>
            </div>
          </section>
        </section>
      </div>
      <PopInvoice
        open={modalInvoiceOpen}
        close={() => setModalInvoiceOpen(false)}
      />
    </main>
  );
};

export default InOutDetail;
